module.exports = __webpack_public_path__ + "img/Mask group.d5f44c9c.svg";